<p-card>

    <ng-template pTemplate="header">
        <div class="flex gap-4">
            <div class="p-card-title">Trip Actual History</div>
            <div class="flex gap-4">
                <app-icon-button [icon]="icons.ppmSolid.add" (onClick)="addComponent()"></app-icon-button>
                @if(componentRefs.length > 1) {
                    <div class="flex items-center gap-1">
                        <label> Per row</label>
                       <p-select [options]="layoutOptions" [(ngModel)]="cols"></p-select>
                    </div>
                }
               
            </div>
        </div>
    </ng-template>


    <div class="dashboard-container">
        <div class="dashboard-grid" [ngClass]="'grid-cols-' + cols">
          <ng-template #componentHost></ng-template>
        </div>
      </div>


</p-card>